export const ARTICLES_GA = {
  category: 'Articles',
  events: {
    articleTabView: 'article_tab_view',
    articleCardClick: 'article_card_click',
    filterLabelClick: 'filter_label_click',
    seeMoreClick: 'see_more_click',
  },
};
